export const environment = {
  production: false,
  googleApiKey: 'AIzaSyCrTVnvt996MFPXLS-HEA6r1JZCbNLe5UM',
  intercomWorkspace: 'kh5l45bz',
  products: {
    guest: {
      signIn: 'https://develop.app.guestgenie.com/login',
    },
    provider: {
      signIn: 'https://develop.provider.guestgenie.com/account/sign-in',
    },
    property: {
      signIn: 'https://develop.property.guestgenie.com/account/sign-in',
    },
  },
  firebase: {
    apiKey: 'AIzaSyBtnoDPuYZtQdOZpMFZUx4VE5HVmdThHEU',
    authDomain: 'website---develop.firebaseapp.com',
    projectId: 'website---develop',
    storageBucket: 'website---develop.firebasestorage.app',
    messagingSenderId: '572153229601',
    appId: '1:572153229601:web:79234bb90f830fd386ce60',
    measurementId: 'G-XT9VS30CVS',
  },
}
